import { createStyles, Theme } from '@material-ui/core/styles';

export default (theme: Theme) =>
  createStyles({
    '.MuiDialog-paperWidthSm-419': {
      'max-width': '900px !important',
    },
    mb2x: {
      marginBottom: theme.spacing.unit * 2,
    },
    mt2x: {
      marginTop: '-26px',
    },
    dialogWidth: {
      width: 960,
      height: 'auto',
    },
    capitalizeText: {
      textTransform: 'capitalize',
    },
    cardHeading: {
      fontWeight: theme.typography.fontWeightRegular,
    },
    requiredHeading: {
      color: theme.palette.secondary.main,
    },
    hintBox: {
      marginTop: '24px',
      border: `1px solid ${theme.palette.grey[300]}`,
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing.unit,
      '& textarea': {
        border: 0,
        padding: 0,
      },
      '& h6': {
        color: theme.palette.grey[400],
      },
      '& .suggested-box': {
        background: theme.palette.common.white,
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing.unit,
        width: '100%',
        marginBottom: theme.spacing.unit,
        '&:last-child': {
          marginBottom: 0,
        },
      },
    },
    greyText: {
      color: '#999',
    },
    deleteButton: {
      display: 'flex',
      alignItems: 'flex-end',
      cursor: 'pointer',
      height: '100%',
      paddingBottom: 10,
    },

    dialogFooter: {
      marginTop: '38px',
      '& p': {
        fontSize: '20px',
      },
      '& p:nth-of-type(2)': {
        fontSize: '14px',
      },
    },
    dialogHeader: {
      marginTop: '38px',
      '& p': {
        fontSize: '20px',
      },
      '& p:nth-of-type(2)': {
        fontSize: '14px',
      },
    },
    divider_or: {
      width: '100%',
      position: 'relative',
      display: 'block',
      height: '25px',
      margin: '15px 0',
      '&::before': {
        content: "''",
        height: '1px',
        background: '#E4E4E4',
        position: 'absolute',
        left: 0,
        top: '14px',
        zIndex: 8,
        width: '100%',
      },
      '&::after': {
        content: "'OR'",
        height: '26px',
        width: '26px',
        background: '#E4E4E4',
        fontWeight: 700,
        fontSize: '10px',
        lineHeight: '27px',
        color: '#989898',
        position: 'absolute',
        left: '50%',
        marginLeft: '-13px',
        top: 0,
        zIndex: 9,
        textAlign: 'center',
        fontStyle: 'italic',
        borderRadius: '50%',
      },
    },
    displayFlexbox: {
      display: 'flex',
      justifyContent: 'flex-end',
      '& button': {
        marginTop: '24px',
      },
    },
    dialogHeightFix: {
      maxHeight: 'initial',
    },
    dialogPaper: {
      maxWidth: '960px',
      maxHeight: 'initial',
      padding: '20px',
      width: '100%',
    },
    errorText: {
      color: '#333',
      verticalAlign: 'middle',
      marginTop: '3px',
      fontSize: "12px !important",
      display: "flex",
      alignItems: "center",
      fontWeight: 400,
      '& svg': {
        verticalAlign: 'bottom',
        fontSize: "14px !important",
        marginRight: '5px',
        fill: '#1d7dea',
      },
    },
    benchTitle: {
      padding: '16px',
    },
    customLink: {
      padding: 0,
    },
    menuPaper: {
      maxHeight: 100,
    },

    okButton: {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: 14,
      lineHeight: '19px',
      letterSpacing: '0.5px',
      color: '#FFFFFF',
      background: '#1D7DEA',
      padding: '4px 22px',
      width: 188,
      borderRadius: 4,
      '&:hover': {
        background: '#1D7DEA',
      },
    },
    headingTxt: {
      fontSize: 16,
      color: '#333',
      textAlign: 'center',
      marginBottom: 12,
      marginTop: 12,
    },
    subTxt: {
      '&>ul': {
        paddingLeft: 15,
        listStyle: 'none',
        '&>li': {
          fontSize: 14,
          color: '#333',
          textAlign: 'center',
          marginBottom: 9,
        }
      },
    },
    blankEntry: {
      '& :focus': {
        background: 'none',
      },
      outline: 'none'
    },
    optionalText: {
      fontSize: '20px',
      color: '#999999',
    },
    redColor: {
      color: '#F21D1D'
    },
    chipLabel: {
      fontSize: 16,
      fontWeight: 400,
      marginBottom: 10,
    },
    customReactSelect: {
      '& > div+div > div': {
        maxHeight: '150px'
      },
      '& .css-1okebmr-indicatorSeparator': {
        background: 'transparent',
      },
    },
    headingRelative: {
      position: 'relative',
    },
    tabsContainer2: {
      margin: "5px 0 10px 0",
      borderRadius: "5px",
      position: "relative",
      "& label": {
        fontSize: 20,
        lineHeight: "22px",
        color: "#333333",
      },
    },
    OrDivider: {
      margin: "50px 0 25px 0",
      display: "block",
      position: "relative",
      textAlign: "center",
      height: "50px",
      zIndex: 0,
    },
    dividerBar: {
      position: "absolute",
      left: 0,
      top: "15px",
      width: "100%",
      content: " ",
      height: "1px",
      background: "#E0E6E7",
      "z-index": "1",
    },
    orText: {
      background: "#E0E6E7",
      height: "40px",
      width: "40px",
      borderRadius: "100%",
      fontStyle: "italic",
      fontSize: 14,
      color: "#989898",
      display: "inline-block",
      paddingTop: "8px",
      position: "absolute",
      top: "-20px",
      left: "47%",
    },
    textAlignCenter: {
      textAlign: "center",
    },
    mb1x: {
      marginBottom: theme.spacing.unit,
    },
    addQuestionTitle: {
      fontSize: 16,
      fontWeight: 400,
      fontFamily: "Nunito",
      paddingRight:10,
    },
    root: {
      flex: 'grow'
    },
    questionInfo: {
      border: `1px solid ${theme.palette.grey[300]}`,
      "& > div": {
        padding: `0 ${theme.spacing.unit}px`
      },
      "& > div:first-child": {
        paddingTop: theme.spacing.unit,
        paddingBottom: theme.spacing.unit,
        borderRight: `1px solid ${theme.palette.grey[300]}`
      }
    },
    questionParagraph: {
      maxWidth: 380,
      '& >p': {
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        margin: '0',
      }
    },
    pTagmargin: {
      "& >p:first-child": {
        margin: "0",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden",
      },
    },
    textAlignRight: {
      textAlign: "right"
    },
    quesId: {
      "& a": {
        display: "initial !important",
      },
    },
    questionActionBtn: {
      padding: 10,
      minWidth: "42px",
      minHeight: "42px",
      border: "1px solid #DFDFDF",
      color: theme.palette.text.secondary,
      borderRadius: 4,
    },
    tabsAlign: {
      display: "flex",
      justifyContent: "space-between",
    },
    addButtonAlign: {
      display: 'flex',
      alignContent: 'center',
    },
    addPageMore: {
      background: '#FFF !important',
      color: '#1D7DEA !important',
      marginRight: 6,
      boxSizing: 'border-box',
      borderRadius: 4,
      fontWeight: 600,
      fontSize: '0.875rem',
    },
    tabsNotes: {
      fontSize: 16,
      fontWeight: 400,
      padding: 0,
      // marginBottom: '15px',
    },
    searchContainer: {
      width: '97%',
    },
    questionSearchContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    addQuestionContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    flexEnd: {
      justifyContent: 'flex-end',
    },
    dialogContent: {
      padding: 0,
      maxHeight: '100%',
      marginTop: 20
    },
    perfectScrollbar: {
      ...theme.mixins.gutters(),
      paddingTop: theme.spacing.unit,
      marginTop: '40px',
      maxHeight: 'inherit',
      background: 'rgb(255, 255, 255)',
      borderRadius: 4,
      '& .ps--active-x > .ps__rail-x, .ps--active-y > .ps__rail-y': {
        opacity: 1
      },
      paddingBottom: 24
    },
    dialogTitle: {
      ...theme.mixins.gutters(),
      paddingTop: theme.spacing.unit,
      paddingBottom: theme.spacing.unit,
      backgroundColor: 'white',
      '& > h6 > div': {
        minHeight: theme.spacing.unit * 7,
      },
      textTransform: 'capitalize',
      borderBottom: '1px solid rgb(226 226 226)',
      position: 'fixed',
      zIndex: 9,
      top: 0,
      left: 0,
      right: 0
    },
    myButtonStyle: {
      marginLeft: '20px',
      minWidth: '44px',
      height: '44px',
      alignSelf: 'center',
    },
    backIconRoot: {
      fill: theme.palette.text.secondary,
      fontSize: 24,
      opacity: 0.5,
      marginBottom: 3
    },
    selectedQuestionStyle: {
      marginRight: '20px',
      fontSize: 16
    },
    pointerCursor: { cursor: 'pointer' },
    paddingTop10: { paddingTop: '10px' },
    dFlex: { display: 'flex' },
    widthAuto: { width: 'auto' },
    maxWidth90: {
      maxWidth: '90%'
    },
    padRgt10:{
      paddingRight:10,
    },
  });